export const languages = ["am", "en", "ru"]